export default __webpack_public_path__ + "static/media/arriving.62aff813.svg";